import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import './styles/index.css';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import { restoreCache, startPersisting } from './lib/persist';
import { applyRememberedLook } from './hooks/useTheme';
import { initMonitoring } from './lib/monitoring';

// apply remembered theme + accent before first paint to avoid a flash
applyRememberedLook();
void initMonitoring();

void restoreCache(queryClient).finally(() => {
  startPersisting(queryClient);
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
